import axios, { AxiosResponse } from "axios";
import useAuthHeaders from "hooks/useAuthHeader";
import useSignOut from 'react-auth-kit/hooks/useSignOut';
import { useQuery } from "react-query";
import { DashboardRevenueResponse } from "types/dashboard-revenue";

interface UseAllRevenueParams {
    start_date?: string;
    end_date?: string;
}

interface GetAllRevenue extends AxiosResponse {
    data: DashboardRevenueResponse
}

const useAllRevenue = (params: UseAllRevenueParams) => {
    const signOut = useSignOut();
    const headers = useAuthHeaders();

    const queryParams = new URLSearchParams(params as unknown as Record<string, string>).toString();

    return useQuery<unknown, unknown, GetAllRevenue>({
        queryKey: ['get-all-revenue'],
        queryFn: async () => {
            try {
                return await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/all/revenue?${queryParams}`, { headers })
            } catch (err) {
                console.error(err);
                if (err?.response?.status === 401) signOut();
            }
        },
    })
}

export default useAllRevenue;